import { useState } from 'react';
import { EmailState } from '../types';

export interface ModalState {
  showReminder: boolean;
  showSia: boolean;
  newSia: boolean;
  newInvoice: boolean;
  email: EmailState | null;
}

/**
 * Hook for managing modal state in the client controls
 * @param initialState Initial state for the modals
 * @returns Object containing state and state management functions
 */
export const useModalState = (initialState: ModalState) => {
  const [state, setState] = useState<ModalState>(initialState);

  const updateState = (key: keyof ModalState, value: any) => {
    setState(prev => ({ ...prev, [key]: value }));
  };

  return {
    state,
    updateState,
    resetEmail: () => updateState('email', null),
  };
}; 